module.exports = __webpack_public_path__ + "media/images/icons/question_answer_avatar-cca5d2747a753921b0637478d16569a6.svg";